enum ROLE {
  SUPER_DUPER_ADMIN = "SUPER_DUPER_ADMIN",
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  ADMIN_NOPII = "ADMIN_NOPII",
  VIEWER = "VIEWER",
  USER = "USER",
  ACCOUNT_SEARCHER = "ACCOUNT_SEARCHER",
}
export default ROLE;
